export const DOCS_ACTION = 'DOCS_ACTION';



/** WEBPACK FOOTER **
 ** ./src/modules/documents/actions/types.js
 **/